import { useCallback, useMemo, useState } from 'react';

const useMenuState = () => {
  const [menuStates, setMenuStates] = useState({
    dashboard: false,
    approvals: false,
    timesheet: false,
    activity: false,
    leaves: false,
    wfh: false,
    applyOt: false,
    loan: false,
    expense: false,
    bonus: false,
    enquiry: false,
    holiday: false,
    admin: false,
    compOff: false,
    travel: false,
    performance: false,
    ticket: false,
    hrTravel: false,
    faq: false,
    employeeMaster: false,
    employeePerformance: false,
    currentState: 'Dashboard',
  });

  const toggleMenuState = useCallback(menuId => {
    setMenuStates(prev => ({
      ...prev,
      [menuId]: !prev[menuId],
      currentState: menuId.charAt(0).toUpperCase() + menuId.slice(1),
    }));
  }, []);

  return useMemo(
    () => ({
      menuStates,
      toggleMenuState,
    }),
    [menuStates, toggleMenuState],
  );
};

export default useMenuState;
